import { Routes } from '@angular/router';

import { setupFeatureFlagsForModule } from '@core/shared/util';
import { provideFacetSelectionService } from '@mp/shared/facets/util';

import { AbstractFavoritesMenuNotifierService } from './common';
import { provideFacetsDataAccess } from './facets';
import { FavoritesMenuNotifierService, provideFavoritesDataAccess } from './favorites';
import { provideHitListsDataAccess } from './hitlists';
import { provideLastViewedArticlesDataAccess } from './last-viewed-articles';
import { provideShoppingCartDataAccess } from './shopping-cart';

const baseTitle = 'medical.shop';

export const MEDICAL_SHOP_ROUTES: Routes = [
  {
    path: '',
    providers: [
      provideFavoritesDataAccess(),
      provideShoppingCartDataAccess(),
      provideFacetsDataAccess(),
      provideFacetSelectionService(),
      { provide: AbstractFavoritesMenuNotifierService, useClass: FavoritesMenuNotifierService },
    ],
    children: [
      {
        path: '',
        redirectTo: 'start',
        pathMatch: 'full',
      },
      {
        path: 'start',
        data: setupFeatureFlagsForModule({ customHeader: true }),
        providers: [provideHitListsDataAccess(), provideLastViewedArticlesDataAccess()],
        loadChildren: async () => (await import('./start-page/start-page.routes')).START_PAGE_ROUTES,
        title: `${baseTitle} | Startseite`,
      },
      {
        path: 'list',
        data: setupFeatureFlagsForModule({ customHeader: true }),
        loadChildren: async () => (await import('./articlesearch/article-search.routes')).ARTICLE_SEARCH_ROUTES,
        title: `${baseTitle} | Ergebnis`,
      },
      {
        path: 'details',
        data: setupFeatureFlagsForModule({ customHeader: true }),
        providers: [provideLastViewedArticlesDataAccess()],
        loadChildren: async () => (await import('./article-details/article-details.routes')).ARTICLE_DETAILS_ROUTES,
        title: `${baseTitle} | Artikeldetails`,
      },
      {
        path: 'hitlists',
        data: setupFeatureFlagsForModule({ customHeader: true }),
        loadChildren: async () => (await import('./hitlists/hitlists.routes')).HITLISTS_ROUTES,
        title: `${baseTitle} | Hitlisten`,
      },
      {
        path: 'favorites',
        data: setupFeatureFlagsForModule({ customHeader: true }),
        loadChildren: async () => (await import('./favorites/favorites.routes')).FAVORITES_ROUTES,
        title: `${baseTitle} | Favoritenliste`,
      },
      {
        path: 'shopping-cart',
        data: setupFeatureFlagsForModule({ customHeader: true }),
        loadChildren: async () => (await import('./shopping-cart/shopping-cart.routes')).SHOPPING_CART_ROUTES,
        title: `${baseTitle} | Warenkorb`,
      },
    ],
  },
];
